import request from "@form/utils/request";

export const pageView = async (): Promise<{}> => {
  return await request.rpc("stat/page_view", {});
};
